// Shared strings
export const LOG_COLLECTION_STRINGS = {
	START_COLLECTING_LOGS: 'Start collecting logs',
	COLLECT_EXISTING_LOGS: 'Collect existing logs',
	LOG_LEVEL_DESCRIPTION:
		"Select the log level and then choose to either **Start collecting logs** to reproduce the issue, or select **Collect existing logs** if you can't reproduce the issue.",
} as const;

// LogCollectionDialog
export const LOG_COLLECTION_DIALOG_STRINGS = {
	LOADING: 'Loading',
	CAPTURING_ISSUES: 'Capturing issues...',
	COLLECTING_LOGS: 'Collecting logs',
	CAPTURING_DESCRIPTION:
		'Reproduce the issue, then select Stop to save the final log file.',
	STOP: 'Stop',
	CANCEL: 'Cancel',
	CANCEL_CONFIRMATION_TITLE: 'Cancel capturing issue?',
	CANCEL_CONFIRMATION_DESCRIPTION: 'The trace file for this log collection will be lost.',
	GO_BACK: 'Go back',
} as const;

// LogFileCard
export const LOG_FILE_CARD_STRINGS = {
	LAST_LOG: 'Last log',
	DOWNLOAD_LOG_FILE: 'Download log file',
	DOWNLOAD: 'Download',
	DELETE_LOG_FILE: 'Delete log file',
	DELETE: 'Delete',
} as const;

// LogCollectionSetting
export const LOG_COLLECTION_SETTING_STRINGS = {
	SELECT_LOG_LEVEL: 'Select Log level',
	SELECT_LOG_LEVEL_DESCRIPTION: 'Select the log level you want to collect.',
} as const;

// CollectLogsPage
export const COLLECT_LOGS_PAGE_STRINGS = {
	PAGE_DESCRIPTION:
		'Log collection for Citrix Workspace app simplifies the process of gathering diagnostic information. These logs help your administrator troubleshoot issues and provide support.',
} as const;

// SendFeedbackPage
export const SEND_FEEDBACK_PAGE_STRINGS = {
	PAGE_DESCRIPTION:
		'Your feedback helps improve Citrix Workspace app. For immediate technical assistance, please contact your administrator.',
	TITLE_LABEL: 'Title',
	FEEDBACK_TITLE: 'Feedback title',
	DESCRIPTION_LABEL: 'Description',
	FEEDBACK_DESCRIPTION: 'Feedback description',
	DESCRIPTION_PLACEHOLDER:
		'Include details such as:\n• Expected result\n• Actual result\n• Steps to reproduce the issue',
	LOGS_CARD_TITLE: 'Logs',
	LOG_LEVEL_LABEL: 'Log level',
	ATTACHMENTS_CARD_TITLE: 'Attachments',
	ATTACHMENTS_CARD_DESCRIPTION:
		'Add any attachments (such as screenshots or screen recordings) to help us identify the issue.',
	CHOOSE_FILE: 'Choose file',
	FILE_SIZE_NOTE: 'File size must not exceed 25 Mb per file',
	FILE_ADDED: 'file',
	FILES_ADDED: 'files',
	ADDED: 'added',
	DELETE: 'Delete',
	CREATE_REPORT: 'Create report',
	REPORT_CREATED: 'Report created',
	REPORT_SAVED_TO: 'Your report was saved to:',
	SEND_REPORT_EMAIL_LABEL: 'Send your report to the following email address',
	COPY_EMAIL_ADDRESS: 'Copy email address',
	CREATE_ANOTHER_REPORT: 'Create another report',
	LOG_LEVEL_LOW: 'Low',
	LOG_LEVEL_MEDIUM: 'Medium',
	LOG_LEVEL_VERBOSE: 'Verbose',
} as const;

// CheckConfigurationPage
export const CHECK_CONFIGURATION_PAGE_STRINGS = {
	PAGE_DESCRIPTION:
		'Run a check to identify misconfiguration issues within Citrix Workspace app.',
	SELECT_CHECK_TYPE: 'Select the type of check to run',
	RUN_CONFIGURATION_CHECK: 'Run configuration check',
	RUN: 'Run',
	RUNNING_CONFIGURATION_CHECKER: 'Running ConfigurationChecker',
	SAVE_REPORT: 'Save report',
	STATUS: 'Status',
	PROVIDER: 'Provider',
	SUITE: 'Suite',
	TEST: 'Test',
	DETAILS: 'Details',
} as const;
